import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatTooltipModule } from "@angular/material/tooltip";
import { RouterModule } from "@angular/router";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { NgChartsModule } from "ng2-charts";
import { routes } from "src/app/app.router";
import { SecurityZoneDashboardComponent } from "./authoring-tools/security-zone-dashboard/security-zone-dashboard.component";
import { SharedModule } from "src/app/shared/shared.module";
import { SecureZoneAuthoringToolsComponent } from "./authoring-tools/secure-zone-authoring-tools.component";
import { MatDialogModule } from "@angular/material/dialog";
import { EnvironmentSearchComponent } from './zone-management/environment/environment-search/environment-search.component';
import { secureZoneRouter } from "./secure-zone.router";
import { ZoneSearchComponent } from "./zone-management/zone/zone-search/zone-search.component";
import { EnvironmentCreateOrUpdateComponent } from './zone-management/environment/environment-create-or-update/environment-create-or-update.component';
import { ZoneCreateOrUpdateComponent } from './zone-management/zone/zone-create-or-update/zone-create-or-update.component';
import { ZoneMapperDialogComponent } from './zone-management/zone/zone-mapper-dialog/zone-mapper-dialog.component';
import { PlatformSearchComponent } from './zone-management/platform/platform-search/platform-search.component';
import { PlatformCreateOrUpdateComponent } from './zone-management/platform/platform-create-or-update/platform-create-or-update.component';
import { ZoneAssetsComponent } from './zone-management/zone/zone-assets/zone-assets.component';
import { SecurityZoneReportsComponent } from './security-zone-reports/security-zone-reports.component';

@NgModule({
  declarations: [
    SecurityZoneDashboardComponent,
    ZoneSearchComponent,
    EnvironmentSearchComponent,
    EnvironmentCreateOrUpdateComponent,
    ZoneCreateOrUpdateComponent,
    ZoneMapperDialogComponent,
     SecureZoneAuthoringToolsComponent,
     PlatformSearchComponent,
     PlatformCreateOrUpdateComponent,
     ZoneAssetsComponent,
     SecurityZoneReportsComponent
  ],
  imports: [
    secureZoneRouter,
    //routes,
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    MatTooltipModule,
    NgbModule,
    NgChartsModule ,
    SharedModule,
    MatDialogModule
  ]
})
export class SecureZoneModule { }